import { CopyButton } from 'modules/common/components/CopyButton';
import { useAuth } from 'modules/auth/hooks/useAuth';

import { PersonalAccountButton } from '../PersonalAccountButton';
import { usePersonalAccountInfoStyles } from './usePersonalAccountInfoStyles';

export interface PersonalAccountInfoProps {
  onAccountButtonClick: () => void;
}

export const PersonalAccountInfo = ({
  onAccountButtonClick,
}: PersonalAccountInfoProps) => {
  const { authAddress, isWeb3Auth } = useAuth();

  const { classes } = usePersonalAccountInfoStyles();

  const hasCopyButton = isWeb3Auth && authAddress;

  return (
    <div className={classes.root}>
      <PersonalAccountButton onClick={onAccountButtonClick} />
      {hasCopyButton && <CopyButton size="medium" text={authAddress} />}
    </div>
  );
};
